import { actionTypes } from '../actions/actionTypes'

const initialState = {
  companies: null,
  loading: null,
  error: null
}

export default (state = initialState, action) => {
  switch(action.type){
  case actionTypes.COMPANIES.SET_COMPANIES:
    return { ...state, ...action.value }
  case actionTypes.COMPANIES.SET_LOADING:
    return { ...state, loading: action.value }
  case actionTypes.COMPANIES.SET_ERROR:
    return { ...state, error: action.value }
  default:
    return state
  }
}